import axios from "axios";
import { apiServer, tokenManager } from "../stores";
import { get } from "svelte/store";

const getHeaders = (method) => {
	const headers = {
		"Content-Type": method == "GET" ? "text/plain" : "application/json",
	};

	const accessToken = tokenManager.getCurrentToken() || sessionStorage.getItem("AccessToken");
	if (accessToken) {
		headers["Authorization"] = accessToken;
	}

	return headers;
};

const getApiUrl = (path) => {
	const currentServer = get(apiServer);
	const protocol = currentServer.includes("localhost") ? "http" : "https";
	return `${protocol}://${currentServer}${path}`;
};

const send = async ({ method = "", path = "", data = {} } = {}) => {
	const url = getApiUrl(path);
	const getToken = tokenManager.getCurrentToken() || sessionStorage.getItem("AccessToken");
	console.log(getToken);
	const headers = {
		"Content-Type": method == "GET" ? "text/plain" : "application/json",
		...(getToken && { Authorization: getToken }),
	};

	const options = {
		method,
		url,
		headers,
		data,
		withCredentials: true,
	};
	try {
		const response = await axios(options);
		return response.data;
	} catch (error) {
		const response = await axios(options);
		return response.data;
	}
};

const getApi = async (url) => {
	try {
		const response = await fetch(getApiUrl(url), {
			method: "GET",
			headers: getHeaders("GET"),
		});
		return await response.json();
	} catch (error) {
		console.error("GET request failed:", error);
		throw error;
	}
};

const putApi = (path, data) => {
	return send({ method: "PUT", path, data });
};

const postApi = async (url, data) => {
	try {
		const response = await fetch(getApiUrl(url), {
			method: "POST",
			headers: getHeaders("POST"),
			body: JSON.stringify(data),
		});
		return await response.json();
	} catch (error) {
		console.error("POST request failed:", error);
		throw error;
	}
};

const delApi = (path, data) => {
	return send({ method: "DELETE", path, data });
};

const patchApi = (path, data) => {
	return send({ method: "PATCH", path, data });
};

const sendFile = async ({ method = "", path = "", data = {} } = {}) => {
	const url = getApiUrl(path);
	const getToken = tokenManager.getCurrentToken() || sessionStorage.getItem("AccessToken");
	const headers = {
		...(getToken && { Authorization: getToken }),
	};
	const options = {
		method,
		url,
		headers,
		data,
	};
	try {
		const response = await axios(options);
		return response.data;
	} catch (error) {
		const response = await axios(options);
		return response.data;
	}
};

const putFileApi = (path, data) => {
	return sendFile({ method: "PUT", path, data });
};

const postFileApi = (path, data) => {
	return sendFile({ method: "POST", path, data });
};

const delFileApi = (path, data) => {
	return sendFile({ method: "DELETE", path, data });
};

// Sound Sources API - 문서에 따른 정확한 구현
export const getSoundSourcesList = (pageSize, page, keyword = "") => {
	let url = `/sound/sources/${pageSize}/${page}`;
	if (keyword && keyword.trim() !== "") {
		url += `/${encodeURIComponent(keyword)}`;
	} else {
		url += `/all`;
	}
	return getApi(url);
};

export const createSoundSource = (formData) => {
	return postFileApi("/sound/source", formData);
};

export const updateSoundSource = (formData) => {
	return putFileApi("/sound/source", formData);
};

export const deleteSoundSource = (id) => {
	return delApi(`/sound/source/${id}`, {});
};

export const refreshSoundSourceCache = () => {
	return putApi("/sound-source/cache", {});
};

export const refreshAiReportPromptCache = () => {
	return putApi("/ai-report-prompt/cache", {});
};

// POC users — 서버 캐시 무효화 + 즉시 재계산
export const refreshPocUsers = () => {
	return postApi("/samsung/poc/users/refresh", {});
};

export { getApi, putApi, postApi, delApi, patchApi, putFileApi, postFileApi, delFileApi };
